import axios from 'axios'

export default axios.create({
  baseURL: 'https://form.datalesson.ru/api/v1/',
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
})
